import React, { useContext, useState, useEffect } from 'react';
import { endpoints } from '../../../config/connections';
import callApi from '../utilities/callApi';
import { downloadZipFile, getQS } from '../../components/utilities/Utils';
import { CBDownloadsContext } from '../../pages/context/CBDownloadsContext';
import { FeatureFlagsContext } from './useFeatureFlags';
import Messages from '../organisms/Messages';
import { getUserId } from '../utilities/Utils';

export const ZipFileDownloader = (closingbindersData) => {
    const { featureDetails } = useContext(FeatureFlagsContext);
    const [successFlag, setSuccessFlag] = useState(false);
    const [failedFlag, setFailedFlag] = useState(false); 
    const [messageContent, setMessageContent] = useState('');
    const { filesList, setFilesList, areDownloadsInProgress, setAreDownloadsInProgress } =
    useContext(CBDownloadsContext);
 
  const updateList = async (list) => {
    setAreDownloadsInProgress(true);
    sessionStorage.setItem('areDownloadsInProgress', 'true');
    let updatedList = [];
    
    zipDownload(list);
   
    if (updatedList?.length > 0) {
      setFilesList({ original: updatedList, filtered: updatedList });
      sessionStorage.setItem(
        'zipdownloadFiles',
        JSON.stringify({ original: updatedList, filtered: updatedList })
      );
    }
    if (
      updatedList?.length > 0 &&
      updatedList.filter(
        (file) => file.downloadStatus == 'Failed' && file.retryCount < 4
      ).length > 0
    ) {
      updateList(updatedList);
    }
  };

  useEffect(() => {
    if (sessionStorage.getItem('zipdownloadFiles')) {
      setFilesList(JSON.parse(sessionStorage.getItem('zipdownloadFiles')));
    }
  }, []);

  useEffect(() => {
   
    sessionStorage.setItem('zipdownloadFiles', JSON.stringify(filesList));
    if (
      filesList.original.filter((file) => file.downloadStatus == 'Pending')
        .length == filesList.original.length ||
      filesList.original.filter(
        (file) => file.downloadStatus == 'Pending' && file.retryCount == 0
      ).length > 0
    ) {
      updateList(filesList.original);
    }
    if (
      filesList.original.filter((file) => file.downloadStatus == 'Pending')
        .length == 0
    ) {
      setAreDownloadsInProgress(false);
    }
  }, [filesList]);

  const zipDownload = async (list) => {
    setSuccessFlag(true);
    setMessageContent("Your download has started. Please check your browser's download section to access the file.");
    window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
          });
     setTimeout(() => {
            setSuccessFlag(false);
          }, 6000);
    let fileList = [];
    if (list?.length > 0) {
      for (let j = 0; j < list.length; j++) {
        if (list[j].downloadStatus != 'Completed' && list[j].retryCount < 4) {
          fileList = [...fileList, list[j].id];
          
        }
      }
    }
    
    if(fileList.length > 1){
       const apiURLPost = `${endpoints.api}/document-management/closing-binders/v1/closingbinders/zipdownload`;
    
       callApi
    .postApiDataBlob(apiURLPost, fileList)
    .then(async (result) => {
       try{
       
        
        const dealName = closingbindersData.closingBinderData?.metadata?.dealName || '';
        const dealId = closingbindersData.closingBinderData?.metadata?.dealId || '';
        const category = closingbindersData.closingBinderData?.category || '';
        let fileName = `${closingbindersData.closingBinderData.closingBinderSequenceNumber}_${dealName}_${category}`;

        if (dealId && !dealName.includes(dealId)) {
          fileName += `_${dealId}`;
        }
        fileName += `.zip`;
         await downloadZipFile(result.data, fileName);
        sessionStorage.setItem('zipdownloadFiles', JSON.stringify({ original: [], filtered: [] }));
        setFilesList({ original: [], filtered: [] });
        setSuccessFlag(true);
            setMessageContent("Download completed successfully.");
            window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth',
                });
            setTimeout(() => {
                    setSuccessFlag(false);
                }, 6000);
} catch (error) {
            setFailedFlag(true);
            setMessageContent("Error downloading zip file. Please try again later.");
            console.error('Error downloading zip file:', error);
        }
    })
    .catch((error) => {
      setFailedFlag(true);
      console.log('error', error);
      if (error?.response?.data?.statusCode !== 200) {
        setMessageContent("Error downloading zip file. Please try again later.");
      }
    });
      return;
    }else if(fileList.length === 1){
       const getApiURL = `${endpoints.envUrl}/document-management/closing-binders/v1/closingbinders/download`;
        
          const userID = getUserId();
           let response = await fetch(getApiURL, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/pdf',
                'user-id': userID,
                'Correlation-ID': userID,
                jwtToken: `${sessionStorage.getItem('tok')}`,
                fileId: list[0].id,
              },
            });
             if (response.status == 200) {
              let blob = await response.blob();
              const url = window.URL.createObjectURL(new Blob([blob]));

              const link = document.createElement('a');
              link.href = url;
              link.download = list[0].name;

              document.body.appendChild(link);

              link.click();
              window.URL.revokeObjectURL(url);
               sessionStorage.setItem('zipdownloadFiles', JSON.stringify({ original: [], filtered: [] }));
               setFilesList({ original: [], filtered: [] });
            }
            
    //  setNormalDownloader(true);
    }
  
  }
 const closeMessage = (setFailedFlag, setSuccessFlag) => {
  setFailedFlag(false);
  setSuccessFlag(false);
};
  return (<> 
  {areDownloadsInProgress ? (<div
              className="message-content"
              data-testid="messageContent"
              role="alert"
            > <Messages
                success={successFlag}
                closeMessage={closeMessage}
                singleUploadFail={failedFlag}
                messageContent={messageContent}
                setFailedFlag={setFailedFlag}
                setSuccessFlag={setSuccessFlag}
                severity={'high'}
                errorContent={"errorContent"}
              /> </div>) : null}


</>);
};
